<template>
  <user-add></user-add>
</template>

<script>

import UserAdd from './../../components/users/add'
export default {
  data: () => ({
  }),
  metaInfo() {
    return {
      title: this.$t('users.add.title')
    }
  },
  components: {
    UserAdd
  }
}
</script>